import { ReduxHelper } from "helpers";
import {
  IPrintCartonRequest,
  IPrintLORequest,
  IPrintRequest,
  IProductionPlan,
} from "model";

export const prefix = "PRINTING";

export const print = ReduxHelper.generateActions<
  IPrintRequest,
  IProductionPlan[]
>(prefix, "PRINT");

export const printCartonBarcode = ReduxHelper.generateActions<
  IPrintCartonRequest,
  any
>(prefix, "PRINT_CARTON_BARCODE");

export const printLO = ReduxHelper.generateActions<IPrintLORequest, any>(
  prefix,
  "PRINT_LO"
);

export const clearReducer = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_REDUCER"
);
